module.exports = __webpack_public_path__ + "static/img/case_detail_12_1.f70306f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_12_1.png
// module id = 8sRK
// module chunks = 34